import { useEffect, useRef, useState } from "react";
import useCanHover from "./useCanHover";

// Tips an element toward the pointer, like a print held in the hand: up to
// `max` degrees of rotateX/Y across its box, easing back to rest when the
// pointer leaves. The element's parent supplies the perspective (CSS).
//
// Only for a pointer that can hover, and never with reduced motion: on touch
// there is no pointer to follow, so it returns no handlers and no transform
// and the element stays still.

const REDUCED_QUERY = "(prefers-reduced-motion: reduce)";

function usePointerTilt(max = 10) {
  const canHover = useCanHover();
  const frame = useRef(0);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  useEffect(() => () => cancelAnimationFrame(frame.current), []);

  if (!canHover) return { style: undefined, handlers: {} };

  const onMouseMove = (event) => {
    if (window.matchMedia(REDUCED_QUERY).matches) return;
    const rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
    cancelAnimationFrame(frame.current);
    frame.current = requestAnimationFrame(() => setTilt({ x: x * max, y: -y * max }));
  };

  const onMouseLeave = () => {
    cancelAnimationFrame(frame.current);
    setTilt({ x: 0, y: 0 });
  };

  return {
    style: { transform: `rotateX(${tilt.y}deg) rotateY(${tilt.x}deg)` },
    handlers: { onMouseMove, onMouseLeave },
  };
}

export default usePointerTilt;
